import type { RouteRecordRaw } from "vue-router";

import { Subject } from "@/services/ability";

import { ROUTE_BASE_NAME } from "./config";

export const routes: RouteRecordRaw[] = [
  {
    path: "billing",
    name: ROUTE_BASE_NAME,
    component: () => import("./views/BillingPage.vue"),
    meta: {
      breadcrumb: "Billing",
      subject: Subject.Billing,
    },
  },
];
